export default {
  hello: 'Hello',
};